import { UserRole, ROLE } from '../common/constants';
import { roleIds } from '../config';

export const userRoles: UserRole[] = [
  {
    id: roleIds.superAdmin,
    displayName: ROLE.SUPERADMIN,
  },
  {
    id: roleIds.admin,
    displayName: ROLE.ADMIN,
  },
  {
    id: roleIds.operator,
    displayName: ROLE.OPERATOR,
  },
  {
    id: roleIds.viewer,
    displayName: ROLE.VIEWER,
  },
];